<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            use-input
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:prepend>
                <q-icon name="night_shelter" />
            </template>

            <template v-slot:selected
                v-if="$attrs.value && $attrs.value.length"
            >
                <span v-if="$attrs.value">
                    <span class="row inline" :key="ii" v-for="(item,ii) in $attrs.value">
                        <div>
                            {{ item.name }}
                            <UserProfileInfo :userProfile="item"
                                :forceType="forceType"
                            />
                        </div>
                        <div class="q-mr-xs" v-if="ii<$attrs.value.length-1">,</div>
                    </span>
                </span>
            </template>

        </q-select>
    </div>
</template>

<script>
    import { ACCOMMODATIONS, ACCOMMODATIONSSEARCH/*, CONTACTS, LOCATIONS*/ } from '@/graphql/accommodation/queries'
    import QSelect from 'quasar'

    export default {
        name: 'AccommodationsInput',
        extends: QSelect,
        props: {
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            forceType: {
                type: String,
                default: "Accommodation"
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            }
        },
        data(){
            return {
                searchTO: {}
            }
        },
        computed: {
            menuItems() {
                if(this.$apollo.queries.accommodations && !this.$apollo.queries.accommodations.loading) return this.accommodations.data
                return new Array();
            }
        },
        methods: {
            search(searchText, updatefn){
                clearTimeout(this.searchTO);
                if(searchText && searchText!=""){
                    this.searchTO=setTimeout(function(){
                        if(this.$apollo.queries.accommodationsSearch){
                            delete this.$apollo.queries.accommodationsSearch
                        }
                        this.$apollo.addSmartQuery('accommodationsSearch', {
                            query: ACCOMMODATIONSSEARCH,
                            fetchPolicy: 'cache-first',
                            error(error){
                                if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                            },
                            variables: {
                                searchText: searchText.trim().split(" ").join("* ")+"*",
                            },
                            manual: true,
                            result ({ data }) {
                                this.accommodations = Object.assign({}, data.accommodationsSearch);
                                updatefn();
                            },
                        })
                    }.bind(this), 200)
                }else{
                    this.$apollo.queries.accommodations.refresh()
                    updatefn();
                }
            }
        },
        apollo: {
            accommodations: {
                query: ACCOMMODATIONS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(accommodations) {
                    accommodations=accommodations.accommodations;

                    setTimeout(function(){
                        this.$refs.myInput.refresh();
                    }.bind(this), 200)

                    return accommodations;
                },
                variables() {
                    if(this.variables) return {...this.variables}
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .accommodations {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }
</style>